import React from 'react';
import { useParams } from 'react-router-dom';

export const UserLinks = ({ userIds }) => {

  let { lang } = useParams();

  return (
    <div>
      {userIds.map((userId) => (
        <a key={userId} className="hover:bg-gray-400 mr-1 text-xs" href={`/${lang}/search/${userId}`}>{userId}</a>
      ))}
    </div>
  );
};
